import Cookies from "js-cookie";
import { combineEpics, Epic, ofType } from "redux-observable";
import { combineLatest, merge } from "rxjs";
import { filter, mapTo, tap } from "rxjs/operators";
import { AppStore } from "..";
import { CookiePolicyActions } from "./actions";
import { COOKIE_NAME } from "./reducer";

const setCookiePreferences: Epic<
  CookiePolicyActions.Actions,
  CookiePolicyActions.Actions,
  AppStore
> = (action$, state$) =>
  combineLatest([
    merge(
      action$.pipe(
        ofType(CookiePolicyActions.ActionTypes.acceptCookies),
        mapTo(true)
      ),
      action$.pipe(
        ofType(CookiePolicyActions.ActionTypes.declineCookies),
        mapTo(false)
      )
    ),
    state$,
  ]).pipe(
    tap(([hasAccepted, state]) => {
      if (hasAccepted) {
        Cookies.set(
          COOKIE_NAME,
          JSON.stringify(state.cookiePolicy.preferences)
        );
      } else {
        Cookies.remove(COOKIE_NAME);
      }

      if ((window as any).gtag) {
        (window as any).gtag("consent", "update", {
          ...state.cookiePolicy.preferences,
        });
      }
    }),
    filter(() => false),
    mapTo(CookiePolicyActions.declineCookies())
  );

export const cookiePolicyEpic = combineEpics(setCookiePreferences);
